<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 发票信息 -->
          <div class="ttshop_coupon min_h">
            <div class="flexsb">
              <div class="fap_title">发票信息</div>
            </div>
            <div>
              <ul>
                <li class="m24">
                  <span class="gwidth">发票类型：</span>
                  <span class="f12" v-if="indetail.type == 1">个人</span>
                  <span class="f12" v-if="indetail.type == 2">企业</span>
                </li>
                <li class="m24">
                  <span class="gwidth">发票类型：</span>
                  <span class="f12" v-if="indetail.invoice_type == 0"
                    >增值税普通票</span
                  >
                  <span class="f12" v-if="indetail.invoice_type == 1"
                    >增值税普通发票</span
                  >
                  <span class="f12" v-if="indetail.invoice_type == 2"
                    >增值税专用发票</span
                  >
                </li>
                <li class="m24" v-if="indetail.header">
                  <span class="gwidth">发票抬头：</span>
                  <span class="f12">{{ indetail.header }}</span>
                </li>
                <li class="m24" v-if="indetail.taxpayer">
                  <span class="gwidth">纳税人识别码：</span>
                  <span class="f12">{{ indetail.taxpayer }}</span>
                </li>
                <li class="m24" v-if="indetail.bank_account">
                  <span class="gwidth">开户行：</span>
                  <span class="f12">{{ indetail.bank_account }}</span>
                </li>
                <li class="m24" v-if="indetail.register_address">
                  <span class="gwidth">注册地址：</span>
                  <span class="f12">{{ indetail.register_address }}</span>
                </li>
                <li class="m24" v-if="indetail.register_tel">
                  <span class="gwidth">注册电话：</span>
                  <span class="f12">{{ indetail.register_tel }}</span>
                </li>
              </ul>
              <div class="flex">
                <div class="del" style="margin-right: 8px" @click="delinvoice">
                  删除
                </div>
                <div class="edit" @click="compileinvoi">编辑</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      invoice_id: "",
      indetail: "",
    };
  },
  mounted() {},
  created() {
    if (this.$route.query.id) {
      this.invoice_id = this.$route.query.id;
    }
    this.getdetails();
  },
  methods: {
    getdetails() {
      var that = this;
      this.$api
        .invoice_detail({
          id: this.invoice_id,
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 0) {
            that.indetail = res.data;
          } else {
            that.$message({
              message: "" + res.msg,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    delinvoice() {
      var that = this;
      this.$confirm("确认是否要删除此发票?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.removeinvo();
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    removeinvo() {
      var that = this;
      this.$api
        .delinvoice({
          id: this.invoice_id,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$message({
              type: "success",
              message: "删除成功!",
            });
            setTimeout(function () {
              that.$router.replace("/ttshop_invoiceInformation");
            }, 500);
          } else {
            that.$message({
              message: "" + res.msg,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 编辑
    compileinvoi(){
      let id=this.invoice_id;
      this.$router.push({
        path:'/ttshop_addinvoice',
        query:{
          id:id
        }
      })
    },
  },
};
</script>

<style  lang="scss" scoped>
.ttshop_coupon {
  width: 100%;
  background: #fff;
  padding: 24px 20px;
  box-sizing: border-box;
  .fap_title {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  .gwidth {
    width: 84px;
    text-align: right;
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  .m24 {
    margin-top: 24px;
  }
  .f12 {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-left: 16px;
  }
  .del {
    width: 78px;
    height: 28px;
    border-radius: 2px;
    border: 1px solid #ff0e25;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff0e25;
    text-align: center;
    line-height: 30px;
  }
  .edit {
    width: 80px;
    height: 30px;
    background: #ff0e25;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 30px;
  }
  .flex {
    display: flex;
    margin-top: 32px;
    margin-left: 127px;
  }
  .color .el-form-item__label {
    color: #999 !important;
  }
}
</style>
